/**
 * Client-side Firebase web config (safe to ship; API key is domain-restricted in Console).
 * Shared by web auth, FCM web registration, and the production service worker bundle.
 */
export const firebasePublicConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyAzDO-bf5yFLAFnCWx16DaMSvTfH98HTI4',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'watchlists-1c639.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'watchlists-1c639',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'watchlists-1c639.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '418607615172',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:418607615172:web:10d2509b05a68f7c864d91',
  /** Web stream GA4 ID; override with REACT_APP_FIREBASE_MEASUREMENT_ID if Console stream differs. */
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'G-D8LWR49JVD',
};
